import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SlotComponent } from '../slot.component';
import { SlotTooltipPipe, DelayDisplayImpurePipe, TranslationKeyPipe } from '../../../pipes';
import { CommonModule } from '@angular/common';
import { LayoutDirective } from '../../../directives';
import { ComponentsModule, slideDown } from '../../../../../lib';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-inline-checkbox',
    templateUrl: './slot-inline-checkbox.component.html',
    styleUrls: ['./slot-inline-checkbox.component.scss'],
    imports: [
        CommonModule,
        MatCheckboxModule,
        LayoutDirective,
        SlotTooltipPipe,
        DelayDisplayImpurePipe,
        TranslationKeyPipe,
        ComponentsModule,
        VisualComponent
    ],
    animations: [slideDown],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotInlineCheckboxComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotInlineCheckboxComponent extends SlotComponent {
    override writeValue(value: boolean): void {
        if (this.slot().dataSource) {
            this.value.set(this.normalizeDataSourceValue(value));
        } else {
            this.value.set(value);
        }
    }

    onValueChange(value: boolean) {
        if (!this.isDisabled) {
            this.value.set(value);
            this.onChange(value);
        }
    }

    onCheckboxChange(event: { checked: boolean }, value: any) {
        let currentValue = Array.isArray(this.value()) ? this.value() : [];
        if (event.checked) {
            currentValue = [...currentValue, value];
        } else {
            currentValue = currentValue.filter((cValue: any) => cValue !== value);
        }
        if (!currentValue.length) {
            currentValue = null;
        }
        this.value.set(currentValue);
        this.onChange(currentValue);
    }

    isSelected(value: any): boolean {
        return this.value()?.includes(value);
    }

    private normalizeDataSourceValue(value: unknown): any[] | null {
        if (Array.isArray(value)) {
            return value;
        }

        if (value === null || value === undefined || value === '') {
            return null;
        }

        if (this.slot().valueConverter) {
            return [value];
        }

        return [];
    }
}
